import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Add as AddIcon,
  Analytics as AnalyticsIcon,
  PlayArrow as PlayArrowIcon,
  Collections as CollectionsIcon,
} from '@mui/icons-material';
import Button from '../UIKit/Button';
import { useTranslation } from 'react-i18next';

const BadgeManagementHeader = ({
  activeTab,
  handleOpenAnalyticsDialog,
  handleOpenCheckDialog,
  handleOpenSeriesCheckDialog,
  handleOpenCreateDialog,
  handleOpenSeriesDialog,
}) => {
  const { t } = useTranslation(['badges']);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
      mb={3}
    >
      <Typography variant="h5" component="h1">
        {t('badges:management.title')}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<AnalyticsIcon />}
          onClick={handleOpenAnalyticsDialog}
        >
          {t('badges:management.badges.analytics')}
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<PlayArrowIcon />}
          onClick={handleOpenCheckDialog}
        >
          {t('badges:management.badges.checkBadges')}
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<CollectionsIcon />}
          onClick={handleOpenSeriesCheckDialog}
        >
          {t('badges:management.series.checkSeries')}
        </Button>
        {activeTab === 0 ? (
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenCreateDialog}
          >
            {t('badges:management.badges.createButton')}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            startIcon={<CollectionsIcon />}
            onClick={() => handleOpenSeriesDialog('create')}
          >
            {t('badges:management.series.createButton')}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default BadgeManagementHeader;
